import React, { memo, useMemo, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Checkbox } from 'antd';
import { sortBy } from '../../../../store/actions/accountReceivableActions/accountReceivableActions';
import { getContentWidth } from '../../../../store/reducers/accountReceivableReducer/helper/general';

const HeaderCell = ({ ind, resource, checkedList, setCheckedList, priceListIDs, allChecked, setAllChecked }) => {
    const dispatch = useDispatch();
    const headers = useSelector((state) => state[resource].headers);
    const sortType = useSelector((state) => state.AccountReceivable.sortType);
    const allHeadersWidthSum = useMemo(() => getContentWidth(headers), [headers]);

    const data = headers[ind];
    const scrollSize = 16;

    const cellStyle = useMemo(() => {
        let width = data.width;
        let style = {
            maxWidth: `${width}px`,
            width: `${width}px`,
            minWidth: `${width}px`,
        };

        if (data.key === 'empty') {
            width = window.innerWidth - allHeadersWidthSum - scrollSize;
            style = {
                ...style,
                maxWidth: `${width}px`,
                width: `${width}px`,
                minWidth: `${width}px`,
                borderLeft: width < 0 ? 'unset' : '1px solid #325353',
                padding: width < 0 ? '0' : 'inherit',
            };
        }

        if (data.leftAction) {
            style = {
                ...style,
                position: 'sticky',
                left: 0,
                maxWidth: `${data.width - 1}px`,
                width: `${data.width - 1}px`,
                minWidth: `${data.width - 1}px`,
            };
        }

        return style;
    }, [data, allHeadersWidthSum]);

    useEffect(() => {
        if (allChecked && checkedList?.length < priceListIDs?.length) {
            setAllChecked(false);
        } else if (!allChecked && checkedList?.length === priceListIDs?.length) {
            setAllChecked(true);
        }
    }, [allChecked, checkedList, priceListIDs, setAllChecked]);

    const handleCheckAllRows = useCallback(() => {
        setAllChecked(prev => {
            const nextChecked = !prev;            
            if (nextChecked) {
                setCheckedList(priceListIDs);
            } else {
                setCheckedList([]);
            }    
            return nextChecked;
        });
    
    }, [priceListIDs, setAllChecked, setCheckedList]);

    const sortableClick = useCallback(() => {
        if (sortType?.sort?.[0] === "ask") {
            dispatch(sortBy(resource, { type: data.key, ind, sort: ['desc'] }));
        } else if (!sortType?.sort) {
            dispatch(sortBy(resource, { type: data.key, ind, sort: ['ask'] }));
        } else {
            dispatch(sortBy(resource, { type: data.key, ind, sort: null }));
        }
    }, [sortType, dispatch, resource, data.key, ind]);

    if (data.key === 'checkbox') {
        return (
            <div className='table-header-cell' style={cellStyle}>
                <div style={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: 'center' }}>
                    <Checkbox 
                        onChange={handleCheckAllRows}
                        checked={allChecked}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            className='table-header-cell'
            style={cellStyle}
            onClick={data.sortable ? sortableClick : undefined}
        >
            <div style={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: 'center' }}>
                {data.title}
            </div>
        </div>
    );
};

export default memo (HeaderCell);